module.exports = __webpack_public_path__ + "img/foot-icon.27979bc7.png";